<template>
<div v-if="currentOrganizationEvents">
    <ul>
        <li class="list-item clickable" v-for="e in currentOrganizationEvents" @click="chooseEvent(e)" :key="e.eventId">
            <h2>{{ e.name }}</h2>
            <div>{{ eventDateDisplay(e) }}</div>
        </li>
    </ul>
</div>
</template>

<script lang="ts">
import { store, Event, User } from "store";
import axios from "axios";
import { defineComponent } from "vue";

export default defineComponent({
    mounted() {
        this.currentOrganizationEvents = store.events
            .filter(e => e.organizationId == store.selectedOrganization.organizationId);
        store.page.title = this.$t("chooseEventView.title") as string;
        store.page.showTopNav = true;
    },
    data() {
        const currentOrganizationEvents: Event[] = null;

        return {
            store: store,
            currentOrganizationEvents
        };
    },
    methods: {
        eventDateDisplay(e: Event): string {
            if (e.eventDate)
                return this.$d(new Date(e.eventDate));
            return "";
        },
        async chooseEvent(event: Event) {
            store.currentUser.selectedEventId = event.eventId;
            if (!store.currentUser.selectedOrganizationId) {
                store.currentUser.selectedOrganizationId = event.organizationId;
            }

            await axios.put<User>(`users/${store.currentUser.userId}`, store.currentUser);

            store.selectedEvent = event;
            this.$router.push('/');
        }
    }
})

</script>